export default "__VITE_ASSET__DUeL8MsT__"